import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Personas } from '../interfaces/personas';
import { Token } from '../interfaces/token';

@Injectable({
  providedIn: 'root'
})
export class PersonasService {

  constructor(private http: HttpClient) { }

  private apiUrl: string = 'https://rest.innova.ar';
  //private apiUrl: string = 'http://localhost:8080';


  getToken(email: string, password: string): Observable<Token>{

    const url = `${this.apiUrl}/auth/login`;

    const dataToSend={
      email: email,
      password: password
    }

    return this.http.post<Token>(url, dataToSend);

  }

  getPersona(idPersona: string, genero: string, token: string): Observable<Personas>{

    const url = `${this.apiUrl}/personas/v1/personas`;

    const dataToSend={
      idPersona: idPersona,
      genero: genero
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })

    const options = {headers: headers};

    return this.http.post<Personas>(url, dataToSend, options);
  }

}
